import { Box, Typography, UserAvatar } from "src/components"
import { useAuth } from "src/utils"

export default function ChatSidebarFooter() {
  const { user } = useAuth()

  if (!user) return;

  return (
    <Box
        sx={{
          position: "sticky",
          bottom: 0,
          bgcolor: "#fafafa",
          borderTop: "1px solid #e0e0e0",
          p: 1,
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <UserAvatar user={user} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="subtitle1" sx={{ color: "#333", fontWeight: 500 }}>
                {user.name}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {user.membership}
            </Typography>
        </Box>
    </Box>
  )
}
